export const illustrationMapping = {
  accident: () => import('./illustrations/accident.svg'),
  allRiskBuilding: () => import('./illustrations/all-risk-building.svg'),
  accountantLiabilityCommercial: () => import('./illustrations/accountant-liability-commercial.svg'),
  advisorLiabilityCommercial: () => import('./illustrations/advisor-liability.svg'),
  attourneyLiabilityCommercial: () => import('./illustrations/attourney-liability.svg'),
  autocamper: () => import('./illustrations/autocamper.svg'),
  boardOfDirectorsLiabilityCommercial: () => import('./illustrations/board-liability.svg'),
  boat: () => import('./illustrations/boat.svg'),
  building: () => import('./illustrations/building.svg'),
  bus: () => import('./illustrations/bus.svg'),
  busCommercial: () => import('./illustrations/bus.svg'),
  businessTravelCommercial: () => import('./illustrations/business-travel.svg'),
  car: () => import('./illustrations/car.svg'),
  carCommercial: () => import('./illustrations/car.svg'),
  collectiveAccidentCommercial: () => import('./illustrations/health.svg'),
  contentCommercial: () => import('./illustrations/content-commercial.svg'),
  contentAndProductLiabilityCommercial: () => import('./illustrations/commercial-product-liability.svg'),
  healthCommercial: () => import('./illustrations/health.svg'),
  caravan: () => import('./illustrations/caravan.svg'),
  cat: () => import('./illustrations/cat.svg'),
  catchAll: () => import('./illustrations/catch-all.svg'),
  commercial: () => import('./illustrations/commercial.svg'),
  digitalSecurity: () => import('./illustrations/digital-security.svg'),
  disusedAgricultureCommercial: () => import('./illustrations/disused-agriculture-commercial.svg'),
  disusedAgricultureHealthLifeAndPensionCommercial: () => import('./illustrations/disused-agriculture-health.svg'),
  agricultureCommercial: () => import('./illustrations/agriculture-commercial.svg'),
  agricultureHealthLifeAndPensionCommercial: () => import('./illustrations/agriculture-health.svg'),
  buildingCommercial: () => import('./illustrations/building-commercial.svg'),
  vanCommercial: () => import('./illustrations/van-commercial.svg'),
  commercialGuide: () => import('./illustrations/commercial-guide.svg'),
  content: () => import('./illustrations/content.svg'),
  contractorsAllRiskCommercial: () => import('./illustrations/contract-commercial.svg'),
  creditCommercial: () => import('./illustrations/credit-commercial.svg'),
  crimeCommercial: () => import('./illustrations/crime-commercial.svg'),
  cyber: () => import('./illustrations/cyber.svg'),
  cyberCommercial: () => import('./illustrations/cyber.svg'),
  dog: () => import('./illustrations/dog.svg'),
  environmentCommercial: () => import('./illustrations/environment-commercial.svg'),
  europeCommercial: () => import('./illustrations/europe.svg'),
  fleetCommercial: () => import('./illustrations/fleet-commercial.svg'),
  guaranteeCommercial: () => import('./illustrations/guarantee-commercial.svg'),
  health: () => import('./illustrations/health.svg'),
  healthWork: () => import('./illustrations/health-work.svg'),
  holidayHouse: () => import('./illustrations/holiday-house.svg'),
  horse: () => import('./illustrations/horse.svg'),
  house: () => import('./illustrations/house.svg'),
  iTLiabilityCommercial: () => import('./illustrations/cyber.svg'),
  kid: () => import('./illustrations/kid.svg'),
  lorry: () => import('./illustrations/lorry.svg'),
  machineAndITLiabilityCommercial: () => import('./illustrations/cyber.svg'),
  materialCommercial: () => import('./illustrations/material-commercial.svg'),
  moped: () => import('./illustrations/moped.svg'),
  mortgage: () => import('./illustrations/mortgage.svg'),
  motorbike: () => import('./illustrations/motorbike.svg'),
  onlineBankCommercial: () => import('./illustrations/cyber.svg'),
  ownerWorkmensCompensationCommercial: () => import('./illustrations/owner-workmen-commercial.svg'),
  patientCommercial: () => import('./illustrations/health.svg'),
  person: () => import('./illustrations/person.svg'),
  pregnancy: () => import('./illustrations/pregnancy.svg'),
  projectLiabilityCommercial: () => import('./illustrations/contract-commercial.svg'),
  salary: () => import('./illustrations/salary.svg'),
  semiTrailer: () => import('./illustrations/semi-trailer.svg'),
  sicknessOperationLossCommercial: () => import('./illustrations/health.svg'),
  tooth: () => import('./illustrations/tooth.svg'),
  toothCommercial: () => import('./illustrations/tooth.svg'),
  trailer: () => import('./illustrations/trailer.svg'),
  trailerCommercial: () => import('./illustrations/trailer.svg'),
  transportCommercial: () => import('./illustrations/transport-commercial.svg'),
  travel: () => import('./illustrations/travel.svg'),
  truck: () => import('./illustrations/truck.svg'),
  truckCommercial: () => import('./illustrations/truck.svg'),
  van: () => import('./illustrations/van.svg'),
  vendorAndWorkshopCommercial: () => import('./illustrations/vendor-workshop.svg'),
  workersCompensation: () => import('./illustrations/workers-compensation.svg'),
  workmensCompensationCommercial: () => import('./illustrations/workers-compensation.svg'),
  workingMachineAndTractorCommercial: () => import('./illustrations/working-machine-tractor.svg'),
  youngLiving: () => import('./illustrations/young-living.svg'),
  // Add more illustrations here
};

export type IllustrationMapping = keyof typeof illustrationMapping;
